const Chart = require('chart.js')

module.exports = {
	config: {
		chartProperties: {
			type: 'bar',
			data: [],
			options: {
				legend: {
					display: true,
					position: 'bottom',
				},
				hover: {
					animationDuration: 0 // duration of animations when hovering an item
				},
				aspectRatio: 2,
				layout: {
					padding: {
						left: 0,
						right: 0,
						top: 0,
						bottom: 0
					}
				}
			}
		},
	},

	model: {
		chartProperties: {}
	},

	methods: {
		getResourceFilters(storage, resourceFilters, actionKey, fieldCode){
			const parentEntity = this.model.parentEntity = this.model.parentEntity || this.getResourceRegisterContent('parentEntity')
			if(parentEntity && actionKey === 'refreshResources'){
				resourceFilters = resourceFilters || {}

				const {
					entityID,
					primaryKey
				} = this.model.parentEntity

				if(primaryKey === 'employeeReportID' && entityID){
					resourceFilters.filters = resourceFilters.filters || {}
					resourceFilters.filters.employeeReportID = entityID
				}
			}

			return resourceFilters
		},

		initChart: function(){
			if(!this.model.chart && this.$.length > 0){
				this.model.chart = new Chart(this.$.find('> .canvasContainer > canvas'), this.model.chartProperties)
			}
		},

		update(data){
			this.initChart()
			const attributes = (data || this.resourceData.data || {}).attributes

			if(this.model.chart && attributes){

				const jobSummary = Object.values(attributes.jobSummary || [])

				this.model.chart.data.labels = jobSummary.map(element => element.code)
				this.model.chart.data.datasets[0] = {
					backgroundColor: '#90C190',
					hoverBackgroundColor: '#006E00',
					label: 'Mitarbeiter',
					data: jobSummary.map(element => element.duration)
				}
				this.model.chart.data.datasets[1] = {
					backgroundColor: '#AAAAAA',
					hoverBackgroundColor: '#666666',
					label: 'Durchschnitt',
					data: jobSummary.map(element => element.avgDuration)
				}

				this.model.chart.update()
			}
		},
	},

	hooks: {
		attach: function($element, options){
			// in case of refreshes the chart-dom-binding has to be renewed
			if (this.model.chart && (options || {}).refresh){
				this.model.chart.destroy()
				delete this.model.chart
			}
			if(!this.model.chart){
				this.model.chartProperties = this.config.chartProperties
				this.model.chartProperties.data = {}
				this.initChart()
			}

			this.update()
		},

		update: function($element, options) {
			this.update((options || {}).employeeReportData)
		},
	}
}
